<template>
  <v-col class="mt-2">
    <v-row v-if="optionShow.speed">
      <v-text-field
        v-model="optionValue.speed"
        dense
        outlined
        :label="$t('option.speed')"
        :suffix="$t('units.seconds')"
        prepend-inner-icon="mdi-play-speed"
        @change="changeSpeed()"
      />
    </v-row>
    <v-row v-if="optionShow.align">
      <v-select
        v-model="optionValue.align"
        :items="optionChoice.align"
        item-text="name"
        item-value="value"
        dense
        outlined
        prepend-inner-icon="mdi-format-align-center"
        :label="$t('option.align')"
        @change="changeAlign()"
      />
    </v-row>
    <v-row v-if="optionShow.size">
      <v-combobox
        v-model="optionValue.size"
        :items="optionChoice.size"
        dense
        outlined
        prepend-inner-icon="mdi-format-size"
        :label="$t('option.size')"
        @change="changeSize()"
      />
    </v-row>
    <v-row v-if="optionShow.font">
      <v-combobox
        v-model="optionValue.font"
        :items="optionChoice.font"
        dense
        outlined
        prepend-inner-icon="mdi-format-font"
        :label="$t('option.font')"
        @change="changeFont()"
      />
    </v-row>
  </v-col>
</template>

<script>
export default {
  props: {
    elementCurrent: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      currentType: "",
      optionChoice: {
        align: [
          { value: "left", name: this.$t("align.left") },
          { value: "center", name: this.$t("align.center") },
          { value: "right", name: this.$t("align.right") },
        ],
        font: this.$store.state.vars.font.family,
        size: this.$store.state.vars.font.size,
      },
      optionShow: {
        align: false,
        font: false,
        size: false,
        speed: false,
      },
      optionValue: {
        align: "left",
        font: this.$store.state.vars.font.default,
        size: 16,
        speed: 5,
      },
    };
  },
  watch: {
    elementCurrent: function (element) {
      // RESET ALL
      this.resetAll();

      // IF ELEMENT NOT NULL
      if (element) {
        this.currentType = element.getType();

        // DEFINE WHAT IS SHOWN AND SET CORRECT VALUES
        switch (this.currentType) {
          case "Calendar":
            this.setCalendarOptions(element);
            break;
          case "Image":
            this.setImageOptions(element);
            break;
          case "Scrolling":
            this.setScrollingOptions(element);
            break;
          case "Weather":
            this.setWeatherOptions(element);
            break;
          default:
            break;
        }
      }
    },
  },
  created() {
    //
  },
  methods: {
    changeAlign() {
      if (this.currentType) {
        const align = this.optionValue.align;

        switch (this.currentType) {
          case "Scrolling":
            this.elementCurrent.konvaObject.children[1].attrs["align"] = align;
            this.elementCurrent.konvaObject.children[2].attrs["align"] = align;
            break;

          default:
            break;
        }
      }
    },
    changeFont() {
      if (this.currentType) {
        const font = this.optionValue.font;
        this.elementCurrent.setFont(font);
      }
    },
    changeSize() {
      if (this.currentType) {
        const size = this.optionValue.size;
        this.elementCurrent.setSize(size);
      }
    },
    changeSpeed() {
      if (this.currentType) {
        const speed = this.optionValue.speed;
        this.elementCurrent.setSpeed(speed);
      }
    },
    resetAll() {
      this.currentType = "";

      this.optionShow.align = false;
      this.optionShow.font = false;
      this.optionShow.size = false;
      this.optionShow.speed = false;

      this.optionValue.align = "left";
      this.optionValue.font = "Calibri";
      this.optionValue.size = 16;
      this.optionValue.speed = 5;
    },
    setImageOptions(img) {
      // SHOW / HIDE OPTIONS
      this.optionShow.align = false;
      this.optionShow.font = false;
      this.optionShow.size = false;
      this.optionShow.speed = true;

      // GET VALUES
      this.optionValue.speed = Math.round(img.sliderTime / 1000);
    },
    setCalendarOptions(cal) {
      // SHOW / HIDE OPTIONS
      this.optionShow.align = false;
      this.optionShow.font = true;
      this.optionShow.size = false;

      // GET VALUES
      this.optionValue.font = cal.konvaObject.attrs.fontFamily;
    },
    setScrollingOptions(scroll) {
      // SHOW / HIDE OPTIONS
      this.optionShow.font = true;
      this.optionShow.size = true;

      // GET VALUES
      this.optionValue.font = scroll.konvaObject.children[1].attrs.fontFamily;
      this.optionValue.size = scroll.konvaObject.children[1].attrs.fontSize;

      // IN VERTICAL MODE SCROLL CAN BE ALIGNED
      if (!scroll.dataScrolling.axe) {
        // SHOW ALIGN OPTION
        this.optionShow.align = true;

        // GET ALIGN VALUE
        this.optionValue.align = scroll.konvaObject.children[1].attrs.align;
      }
    },
    setWeatherOptions(weather) {
      // SHOW / HIDE OPTIONS
      this.optionShow.align = false;
      this.optionShow.font = true;
      this.optionShow.size = false;

      // GET VALUES
      this.optionValue.font = weather.dataWeather.font;
    },
  },
};
</script>
